import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { Card } from '../Card/Card.js';
import '../Text/index.js';
import '../Box/index.js';
import { useModalContext } from './Modal.js';

const StyledModalContent = styled(Card).withConfig({
  displayName: "ModalContent__StyledModalContent",
  componentId: "sc-1y1mnid-0"
})(["transform:translate(-50%,-50%);"]);
const ModalContent = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    dataTestId = 'modal-content',
    children,
    ...rest
  } = _ref;
  const {
    headerId,
    bodyId,
    contentId
  } = useModalContext();
  return /*#__PURE__*/React__default.createElement(StyledModalContent, _extends({
    ref: forwardedRef,
    "aria-describedby": bodyId,
    "aria-labelledby": headerId,
    "aria-modal": "true",
    bg: "background",
    "data-test-id": dataTestId,
    id: contentId,
    left: "50%",
    maxWidth: "400px",
    position: "fixed",
    role: "dialog",
    top: "50%",
    width: "100%",
    zIndex: "modal",
    onClick: e => {
      e.stopPropagation();
    },
    onKeyDown: e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
      }
    }
  }, rest), children);
});

export { ModalContent };
